@if (thumbnailUrl(); as url) {
	<span tuiAvatar="@tui.notebook-pen" [size]="size()" [round]="false">
		<img [src]="url" alt="" />
	</span>
} @else {
	<span tuiAvatar="@tui.notebook-pen" [size]="size()" [round]="false"></span>
}
